'use client';

import { useRef } from 'react';
import { useIntl } from 'react-intl';

import { TrustpilotMiniTrustScoreWidget } from '../../../../../shared/components/Trustpilot/MiniTrustScoreWidget';
import { useTrackBlockViewed } from '../../../../../shared/hooks/useTrackBlockViewed';

import style from './UgcSectionTitle.module.css';

export function UgcSectionTitle() {
    const { formatMessage } = useIntl();
    const trustpilotRef = useRef<HTMLDivElement>(null);

    useTrackBlockViewed(trustpilotRef, 'trustpilot');

    return (
        <div className={style.container}>
            <div className={style.title}>
                {formatMessage({
                    id: 'page.home.ugcSection.title',
                })}
            </div>
            <div ref={trustpilotRef} className={style.trustpilot}>
                <TrustpilotMiniTrustScoreWidget />
            </div>
        </div>
    );
}
